<template>
    <div class="dashboard">
        <div class="status-group">
            <span class="title">
                {{ $t('talk.feedbackStatus').toUpperCase() }}
            </span>
            <div class="report-container">
                <report
                    v-for="report in dashboards"
                    :key="`report-${report.type}-${report.count}`"
                    :title="report.title"
                    :count="report.count"
                    :icon="report.icon"
                />

                <category-report />
            </div>
        </div>
    </div>
</template>

<script>
import { EventBuzz } from '@/main'
import { Report, CategoryReport } from './children'
import { getCount } from '@/views/talk/feedbacks/children/api'

export default {
    name: 'Dashboard',
    components: { Report, CategoryReport },
    data() {
        return {
            filters: {},
            role: 'user',
            counts: {
                sent: {},
                received: {},
            },
        }
    },
    mounted() {
        this.getReport()
        EventBuzz.$on('update-talk-summary', this.getReport)
        EventBuzz.$on('feedback-filters-changed', this.setFilters)
        EventBuzz.$on('roleChanged', this.setRole)
    },
    methods: {
        getReport() {
            const types = ['sent', 'received']
            getCount(
                this.currentUser.id,
                this.filters,
                types,
                this.role,
                true
            ).then(res => this.setCountToData(res))
        },
        setCountToData(data) {
            Object.keys(data).forEach(type => {
                this.counts[type] = data[type]
            })
        },
        setFilters(filters) {
            this.filters = filters
        },
        setRole(role) {
            this.role = role
        },
    },
    computed: {
        currentUser() {
            return this.$store.state.currentUser.user
        },
        dashboards() {
            const dashboards = []
            const sentTitle = this.$t('profile.feedback.sent').toUpperCase()
            const receivedTitle = this.$t(
                'profile.feedback.received'
            ).toUpperCase()

            const sent = {
                title: sentTitle,
                type: 'sent',
                icon: 'fa-arrow-up',
                count: this.counts.sent,
            }

            const received = {
                title: receivedTitle,
                type: 'received',
                icon: 'fa-arrow-down',
                count: this.counts.received,
            }

            if (this.role === 'administrator') {
                received.title = sentTitle
                dashboards.push(received)
            } else {
                dashboards.push(sent, received)
            }

            return dashboards
        },
    },
    watch: {
        role() {
            this.getReport()
        },
        filters() {
            this.getReport()
        },
    },
}
</script>
<style lang="sass" scoped>
.status-group
    display: flex
    flex-direction: column
    width: 100%
    margin-bottom: 20px
    .title
        font-size: 13px
        color: #6f6f6f
        font-weight: 400
        margin-bottom: 5px
    .report-container
        width: 100%
        display: flex
        justify-content: center
        flex-wrap: wrap
        flex-direction: row
        justify-content: center
        padding: 0 10px

@media (min-width: 751px)
    .status-group
        .report-container
            padding: 0 100px
@media (min-width: 984px)
    .status-group
        .report-container
            padding: 0 150px
@media (min-width: 1024px)
    .status-group
        .report-container
            justify-content: flex-start
            padding: 0
</style>
